import FeatureFlagsStore from 'stores/feature-flags'
import datadog from 'utils/datadog'
import { getRoute } from 'utils/routes'
import { PATHNAMES } from 'utils/routes/consts'

/**
 * Retrieves the territory URL based on the provided territoryId.
 *
 * @param territoryId - The territoryId of the territory.
 * @param workspaceId - The ID of the workspace.
 * @returns The territory link.
 * @throws {Error} If an argument was provided.
 */

export function getTerritoryUrlByTerritoryId(territoryId: string, workspaceId: string): string {
  const [type, id] = territoryId.split('.')

  if (type === 'industry_topic') {
    const hasAccessToIndustryCategory = FeatureFlagsStore.isFeatureFlagEnabled('hasAccessToIndustryCategory')
    return hasAccessToIndustryCategory
      ? getRoute(PATHNAMES.INDUSTRY_CATEGORY, {
          entityId: id,
          panelId: workspaceId,
        })
      : getRoute(PATHNAMES.WORKSPACE_TOPIC, {
          panelId: workspaceId,
          entityId: id,
        })
  }

  if (type === 'global_topic') {
    const topicRoute = getRoute(PATHNAMES.WORKSPACE_GLOBAL_TOPIC, {
      panelId: workspaceId,
      entityId: id,
    })
    return topicRoute
  }

  if (type === 'global_topic') {
    const topicRoute = getRoute(PATHNAMES.WORKSPACE_GLOBAL_TOPIC, {
      panelId: workspaceId,
      entityId: id,
    })
    return topicRoute
  }

  if (type === 'topic') {
    const topicRoute = getRoute(PATHNAMES.WORKSPACE_TOPIC, {
      panelId: workspaceId,
      entityId: id,
    })
    return topicRoute
  }

  if (type === 'subtopic') {
    const subtopicRoute = getRoute(PATHNAMES.WORKSPACE_SUBTOPIC, {
      panelId: workspaceId,
      entityId: id,
    })
    return subtopicRoute
  }

  if (type === 'brand_territory') {
    const brandRoute = getRoute(PATHNAMES.WORKSPACE_BRAND, { panelId: workspaceId, entityId: id })
    return brandRoute
  }

  if (type === 'trending_subject') {
    const trendingTagRoute = getRoute(PATHNAMES.WORKSPACE_TRENDING_TAG, {
      panelId: workspaceId,
      entityId: `trending_subject.${id}`,
    })
    return trendingTagRoute
  }

  if (type === 'niche') {
    const nicheRoute = getRoute(PATHNAMES.WORKSPACE_NICHE, { panelId: workspaceId, entityId: id })
    return nicheRoute
  }

  if (type === 'saved_search') {
    const savedSearchRoute = getRoute(PATHNAMES.WORKSPACE_SAVED_SEARCH, {
      panelId: workspaceId,
      entityId: id,
    })
    return savedSearchRoute
  }

  if (type === 'trending') {
    const trendingRoute = getRoute(PATHNAMES.WORKSPACE_TRENDING, {
      panelId: workspaceId,
      entityId: id,
    })
    return trendingRoute
  }

  if (type === 'tag') {
    const tagRoute = getRoute(PATHNAMES.WORKSPACE_TAG, {
      panelId: workspaceId,
      entityId: id,
    })
    return tagRoute
  }

  datadog.dispatchGenericErrorLog({
    log: {
      from: 'src > utils > getTerritoryUrlByTerritoryId',
      name: 'Invalid type or typename',
      message: `Invalid type or typename: ${type}`,
    },
    error: new Error(`Invalid type or typename: ${type}`),
  })

  return '#'
}
